<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="mdi-format-list-checkbox"
    ></vuse-section-definition>

    <v-row class="fill-width">
      <v-col cols="12" md="12" lg="8" class="mb-5">
        <v-row class="mx-3 mt-4">
          <v-col class="mx-3" cols="3.5" sm="3.5">
            <v-text-field
                filled
                hide-details
                class="mt-3"
                v-model="warranty.keyword"
                label="Thông tin khách hàng"
                placeholder="Nhập thông tin khách hàng"
                @input="debounceInput"
            ></v-text-field>
          </v-col>
          <v-col class="mx-3" cols="3.5" sm="3.5">
            <v-select
                filled
                hide-details
                class="width-input mt-3"
                v-model="warranty.warranty_status"
                :items="warranty_status"
                clearable
                item-text="name"
                item-value="id"
                label="Trạng thái bảo hành"
                @change="getItem"
            ></v-select>
          </v-col>
          <v-col class="mx-3" cols="3.5" sm="3.5">
            <v-select
                filled
                hide-details
                class="width-input mt-3"
                v-model="warranty.status"
                :items="active"
                clearable
                item-text="name"
                item-value="id"
                label="Trạng thái kích hoạt"
                @change="getItem"
            ></v-select>
          </v-col>
          <v-col class="mx-3" cols="3.5" sm="3.5">
            <v-text-field
                filled
                hide-details
                class="mt-3"
                v-model="warranty.stamp"
                label="Mã tem sản phẩm"
                placeholder="Nhập thông tin mã tem"
                @input="searchStamp"
            ></v-text-field>
          </v-col>
          <v-col class="mx-3" cols="3.5" sm="3.5">
            <v-text-field
                filled
                hide-details
                class="mt-3"
                v-model="warranty.phone"
                label="SĐT khách hàng"
                placeholder="Nhập thông tin SĐT"
                @input="searchPhone"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="12" lg="4" align="right" class="mt-0 mt-md-8">
        <v-btn
            class="mt-1 mt-md-2"
            color="primary"
            align="right"
            @click="addNewByFileExcel"
            v-if="hasPermissions('Import excel warranty')"
        >
          Thêm mới bằng file Excel
        </v-btn>
        <v-btn
            :loading="loading"
            class="ml-3 mt-1 mt-md-2 "
            color="primary"
            align="right"
            @click="exportExcel"
            v-if="hasPermissions('Export excel show_room')"
        >
          <span slot="loader">Đang xử lý...</span>
          Xuất excel
        </v-btn>
        <v-btn color="primary" align="right" class="ml-3 mt-1 mt-md-2" @click="addNew" v-if="hasPermissions('Create warranty')">
          Thêm
        </v-btn>
      </v-col>
    </v-row>

    <v-container fluid>
      <v-row justify="center" align="center">
        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="warranties.warranties"
              class="elevation-1"
            :server-items-length="totalItemCount"
            :options.sync="pagination"
          >
            <template v-slot:item.warranty_status="{ item }">
             <span v-if="item.status == 1" class="red--text font-weight-bold">CHƯA BẢO HÀNH</span>
             <span v-else class="primary--text font-weight-bold">ĐÃ BẢO HÀNH</span>
            </template>
            <template v-slot:item.status="{ item }">
              <span v-if="item.warranty_status == 1" class="red--text font-weight-bold">CHỜ KÍCH HOẠT</span>
              <span v-else-if="item.warranty_status == 2" class="primary--text font-weight-bold">ĐÃ KÍCH HOẠT</span>
              <span v-else class="font-weight-bold">KHÔNG KÍCH HOẠT</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)" v-if="hasPermissions('Update warranty')">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item.id)" v-if="hasPermissions('Delete warranty')"> mdi-delete </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
        v-model="dialog"
        max-width="500"
        persistent
    >
      <v-card class="rounded-lg">
        <v-card-title class="d-flex justify-center">
          Thêm mới kích hoạt bảo hành bằng file Excel
        </v-card-title>

        <v-card-text>
          <v-row class="mt-5">
            <v-col cols="12">
              <v-file-input
                  label="File Excel"
                  placeholder="File Excel"
                  prepend-icon="mdi-file-excel"
                  @change="fileSelected"
              ></v-file-input>
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col cols="12" class="d-flex justify-end">
                  <v-btn
                      @click="dialog = false"
                  >
                    Hủy
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import { DELETE_WARRANTY ,GET_DATA_SEARCH, IMPORT_EXCEL_WARRANTY, EXPORT_EXCEL_WARRANTY} from "@/store/modules/warranty";
import { mapGetters } from "vuex";
import {debounce} from "debounce";
import { db } from "@/utils/firebaseDb";

export default {
  data() {
    return {
      loading: false,
      dialog: false,
      totalItemCount: 10,
      pagination: {
          page: 1,
          rowsPerPage: 10,
          itemsPerPage: 10,
          totalItems: 0
      },
      page: "Kích hoạt bảo hành",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true
        },
        {
          text: "Bảo hành",
          disabled: true,
        },
        {
          text: "Kích hoạt bảo hành",
          disabled: true,
        },
      ],
      warranty: {
        keyword:"",
        status:"",
        warranty_status:"",
        limit: 10,
        stamp: '',
        phone: '',
      },
      active: [
        {id:1, name:'CHƯA BẢO HÀNH'},
        {id:2, name:'ĐÃ BẢO HÀNH'},
      ],
      warranty_status: [
        {id:1, name:'CHƯA KÍCH HOẠT'},
        {id:2, name:'ĐÃ KÍCH HOẠT'},
        {id:3, name:'KHÔNG KÍCH HOẠT'},
      ],
      headers: [
        { text: "STT", value: "id" },
        { text: "Mã tem SP", value: "stamp" },
        { text: "Tên SP", value: "name_product" },
        { text: "Seriel", value: "seri" },
        {
          text: "Tên khách hàng",
          align: "start",
          sortable: false,
          value: "customer_fullname",
        },
        { text: 'SĐT', value: 'customer_phone' },
        { text: 'Địa chỉ', value: 'customer_address' },
        { text: 'Ngày xuất kho', value: 'buy_date' },
        { text: 'Ngày hết hạn bảo hành', value: 'end_date' },
        { text: 'Tình trạng bảo hành (Đã kích hoạt/ Chưa kích hoạt)', value: 'status' },
        { text: 'Actions', value: 'actions' },
      ],
      url: "",
    };
  },
  computed: {
    ...mapGetters({
      warranties: "dataSearchWarranties",
    }),
  },

  async created() {
    this.url = process.env.VUE_APP_API_URL;
    await this.$store.dispatch(GET_DATA_SEARCH, this.getParams());
    console.log(this.warranties)
  },
  watch:{
      warranties(val){
        this.totalItemCount = val.paginate.total
      },
      pagination: {
          handler() {
              this.debounceInput(this.warranty.keyword, 'page');
          },
          deep: true
      },
  },
  methods: {
    debounceInput: debounce(function (e, page = '') {
      this.warranty.keyword = e;
      if(page != 'page' && this.pagination.page != 1){
          this.pagination.page = 1;
          return;
      }
      this.$store.dispatch(GET_DATA_SEARCH, this.getParams());
    }, 200),

    searchStamp(e) {
      this.warranty.stamp = e
      this.$store.dispatch(GET_DATA_SEARCH, this.getParams());
    },
    searchPhone(e) {
      this.warranty.phone = e
      this.$store.dispatch(GET_DATA_SEARCH, this.getParams());
    },

    getItem() {
      this.debounceInput(this.warranty.keyword);
    },
    editItem(item) {
      this.$router.push(
          "/manage_warranty/edit_warranty/" + item.id
      );
    },

    deleteItem(id) {
      confirm("Bạn có chắc muốn xóa?") &&
      this.$store.dispatch(`${DELETE_WARRANTY}`, id).then((data) => {
        if (data) {
          this.debounceInput(this.warranty.keyword);
        }
      });
    },
    addNew() {
      this.$router.push("/manage_warranty/add_warranty");
    },
    getParams() {
      console.log(this.warranty.stamp)
      return {
        keyword: this.warranty.keyword,
        status: this.warranty.status != "-1" ? this.warranty.status : null,
        warranty_status: this.warranty.warranty_status != "-1" ? this.warranty.warranty_status : null,
        limit : this.pagination.itemsPerPage,
        page : this.pagination.page,
        stamp: this.warranty.stamp,
        phone: this.warranty.phone,
      };
    },
    addNewByFileExcel(){
      this.dialog = true;
    },
    fileSelected(event) {
      const _this = this;
      console.log(event);
      if (event) {
        let formData = new FormData();
        formData.append("file", event);
        this.$store.dispatch(`${IMPORT_EXCEL_WARRANTY}`, formData).then((data) => {
          if (data && data.data && data.data.status == 1) {
            this.$toasted.success('Thêm mới thành công!', {
              duration:1000,
              position:'top-center'
            })
          }else{
            this.$toasted.error('Thêm mới thất bại!', {
              duration:1000,
              position:'top-center'
            })
          }
        }).catch(() => {
          this.$toasted.error('Thêm mới thất bại!', {
            duration:1000,
            position:'top-center'
          })
        });
      }
      _this.dialog = false;
    },
    s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    },
    exportExcel() {
        this.loading = true;
        this.$store.dispatch(`${EXPORT_EXCEL_WARRANTY}`, {}).then((data) => {
          if(data.data.data){
            db.ref(`export/warranty/${data.data.data}`).on('value',event =>{
              if(event.val()){
                this.downloadExcel();
              }
            });
          }else{
            alert("Đã có lỗi xảy ra!");
          }
        });
    },
    downloadExcel() {
        this.$store.dispatch(`${EXPORT_EXCEL_WARRANTY}`, {download: 1}).then((data) => {
          this.loading = false;
          var tagA = document.createElement("a");
          var blob = new Blob([this.s2ab(atob(data.data))], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'
          });
          let FILE = window.URL.createObjectURL(blob);
          tagA.href = FILE;
          tagA.download = "export-warranty.xls";
          tagA.click();
        });
    },
  },
};
</script>
<style scoped lang="scss">
.content_category1 {
  background: #ffffff !important;
}
.width-input {
  max-width: 240px!important;
}
.img-brand {
  max-width: 100px;
  max-height: 100px;
  margin: auto;
  display: block;
}
</style>
